import ErinRed from 'src/_shared/assets/erin_square.png';
import ErinGray from 'src/_shared/assets/erin_lightgray.png';

const ElevatedPermissionsToggle = ({
	showAdminControls,
	toggleAdminControls,
	currentUser,
	style = {},
}) => {
	const elevatedPermissions =
		currentUser?.admin && JSON.parse(currentUser.admin)?.permissions === '*';
	if (!elevatedPermissions) return null;
	return (
		<button
			className="elevated-permissions-toggle"
			onClick={toggleAdminControls}
			style={{
				outline: 'none',
				minWidth: '24px',
				marginLeft: '16px',
				...style,
			}}
		>
			<img
				src={showAdminControls ? ErinRed : ErinGray}
				alt="Toggle Admin Controls"
				style={{
					width: '24px',
					height: '24px',
				}}
			/>
		</button>
	);
};

export default ElevatedPermissionsToggle;
